export enum MutationKeys {
  PRODUCTION = "production",
  TAKE_HOME = "take-home",
  PRODUCTION_PLANNING = "production-planning",
  PRODUCTION_PLANNING_COPY_FROM = 'production-planning-copy-from',
  DELETE_ALL_FUTURE_BUILD_TO = 'delete-all-future-build-to',
  PREP = 'PREP',
  PRODUCT_PREP_ITEMS = 'PRODUCT_PREP_ITEMS',
  ORDER_LIST_MASTER_DATA = 'ORDER_LIST_MASTER_DATA'
}
